import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { showToast } from 'app/shared/util/toast.util';
import { messages } from 'app/config/constants';
import { revalidateCaseActsThunk } from 'app/shared/reducers/validationerrors/validation-errors.reducer';
import getStore from 'app/config/store';

function parseBool(v: string | null) {
  if (v == null) return null;
  if (/^(true|1|yes)$/i.test(v)) return true;
  if (/^(false|0|no)$/i.test(v)) return false;
  return null;
}

export default function EsignResultWatcher() {
  const dispatch = getStore().dispatch;
  const location = useLocation();

  const params = React.useMemo(() => {
    const raw = location.search.startsWith('?') ? location.search.slice(1) : location.search;
    const fixed = raw.replace(/\?/g, '&');
    return new URLSearchParams(fixed);
  }, [location.search]);

  React.useEffect(() => {
    const success = parseBool(params.get('esignSuccess'));

    if (success == null) {
      return;
    } else if (success) {
      showToast(toast.success, messages.DOCUMENT_SIGNED);
      dispatch(revalidateCaseActsThunk());
    } else {
      showToast(toast.error, messages.DOCUMENT_NOT_SIGNED);
    }
  }, [params, location.pathname, location.hash]);

  return null;
}
